import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { BarcodeScanModalComponent } from './barcode-scan-modal.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';

@NgModule({
  declarations: [BarcodeScanModalComponent],
  imports: [
    CommonModule,
    IonicModule,
    MatFormFieldModule,
    FormsModule,
    MatInputModule,
    TranslateModule,
  ],
  exports: [BarcodeScanModalComponent],
  providers: [],
})
export class BarcodeScanModalModule {}
